var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.errorComponent.name,_vm._b({tag:"component",attrs:{"data-testid":"error-state-component"},on:{"onClickButton":_vm.onClick}},'component',_vm.errorComponent.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }